import { OutboundAppButtonClass } from './component/OutboundAppButtonClass';

const compVars = OutboundAppButtonClass.cssVarList;

const outboundAppButton = {
  [compVars.iconFillCurrentColor]: 'inherit',

  _iconFillCurrentColor: {
    [compVars.iconFillCurrentColor]: 'currentColor',
  },

  _fullWidth: {
    [compVars.hostWidth]: '100%',
  },
};

export default outboundAppButton;

export const vars = compVars;
